var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/@lumino/widgets": () => (loadSingletonVersion("default", "@lumino/widgets", false, [1,2,3,1,,"alpha",0])),
	"webpack/sharing/consume/default/jquery/jquery?123b": () => (loadStrictVersion("default", "jquery", false, [1,3,1,1], () => (__webpack_require__.e("vendors-node_modules_jquery_dist_jquery_js").then(() => (() => (__webpack_require__(/*! jquery */ "../../node_modules/jquery/dist/jquery.js"))))))),
	"webpack/sharing/consume/default/@lumino/coreutils": () => (loadSingletonVersion("default", "@lumino/coreutils", false, [1,2,0,0])),
	"webpack/sharing/consume/default/@jupyter-widgets/base/@jupyter-widgets/base": () => (loadStrictVersion("default", "@jupyter-widgets/base", false, [1,6,0,11], () => (Promise.all([__webpack_require__.e("vendors-node_modules_backbone_backbone_js-node_modules_lodash_isEqual_js"), __webpack_require__.e("webpack_sharing_consume_default_lumino_widgets-webpack_sharing_consume_default_jquery_jquery"), __webpack_require__.e("webpack_sharing_consume_default_lumino_coreutils"), __webpack_require__.e("webpack_sharing_consume_default_lumino_messaging"), __webpack_require__.e("packages_base_lib_index_js-webpack_sharing_consume_default_jquery_jquery")]).then(() => (() => (__webpack_require__(/*! @jupyter-widgets/base */ "../../packages/base/lib/index.js"))))))),
	"webpack/sharing/consume/default/@lumino/algorithm": () => (loadSingletonVersion("default", "@lumino/algorithm", false, [1,2,0,0])),
	"webpack/sharing/consume/default/@lumino/signaling": () => (loadSingletonVersion("default", "@lumino/signaling", false, [1,2,0,0])),
	"webpack/sharing/consume/default/@jupyterlab/settingregistry": () => (loadSingletonVersion("default", "@jupyterlab/settingregistry", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/console": () => (loadSingletonVersion("default", "@jupyterlab/console", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/notebook": () => (loadSingletonVersion("default", "@jupyterlab/notebook", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/mainmenu": () => (loadSingletonVersion("default", "@jupyterlab/mainmenu", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/rendermime": () => (loadSingletonVersion("default", "@jupyterlab/rendermime", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/logconsole": () => (loadSingletonVersion("default", "@jupyterlab/logconsole", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@lumino/disposable": () => (loadSingletonVersion("default", "@lumino/disposable", false, [1,2,0,0])),
	"webpack/sharing/consume/default/@jupyter-widgets/base-manager/@jupyter-widgets/base-manager": () => (loadStrictVersion("default", "@jupyter-widgets/base-manager", false, [1,1,0,12], () => (Promise.all([__webpack_require__.e("vendors-node_modules_base64-js_index_js-node_modules_sanitize-html_index_js"), __webpack_require__.e("packages_base-manager_lib_index_js")]).then(() => (() => (__webpack_require__(/*! @jupyter-widgets/base-manager */ "../../packages/base-manager/lib/index.js"))))))),
	"webpack/sharing/consume/default/semver/semver": () => (loadStrictVersion("default", "semver", false, [1,7,3,5], () => (__webpack_require__.e("vendors-node_modules_semver_index_js").then(() => (() => (__webpack_require__(/*! semver */ "../../node_modules/semver/index.js"))))))),
	"webpack/sharing/consume/default/@jupyter-widgets/output/@jupyter-widgets/output": () => (loadStrictVersion("default", "@jupyter-widgets/output", false, [1,6,0,11], () => (__webpack_require__.e("packages_output_lib_index_js").then(() => (() => (__webpack_require__(/*! @jupyter-widgets/output */ "../../packages/output/lib/index.js"))))))),
	"webpack/sharing/consume/default/@jupyterlab/outputarea": () => (loadVersion("default", "@jupyterlab/outputarea", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/services": () => (loadSingletonVersion("default", "@jupyterlab/services", false, [1,7,4,6])),
	"webpack/sharing/consume/default/@jupyterlab/translation": () => (loadSingletonVersion("default", "@jupyterlab/translation", false, [1,4,4,6])),
	"webpack/sharing/consume/default/@lumino/messaging": () => (loadSingletonVersion("default", "@lumino/messaging", false, [1,2,0,0])),
	"webpack/sharing/consume/default/jquery/jquery?5edd": () => (load("default", "jquery", false, () => (__webpack_require__.e("vendors-node_modules_jquery_dist_jquery_js").then(() => (() => (__webpack_require__(/*! jquery */ "../../node_modules/jquery/dist/jquery.js"))))))),
	"webpack/sharing/consume/default/@lumino/domutils": () => (loadSingletonVersion("default", "@lumino/domutils", false, [1,2,0,0])),
	"webpack/sharing/consume/default/@jupyter-widgets/controls/@jupyter-widgets/controls": () => (loadStrictVersion("default", "@jupyter-widgets/controls", false, [1,5,0,12], () => (Promise.all([__webpack_require__.e("vendors-node_modules_d3-color_src_color_js-node_modules_d3-format_src_defaultLocale_js-node_m-09b215"), __webpack_require__.e("webpack_sharing_consume_default_lumino_messaging"), __webpack_require__.e("packages_controls_lib_index_js")]).then(() => (() => (__webpack_require__(/*! @jupyter-widgets/controls */ "../../packages/controls/lib/index.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_lumino_widgets-webpack_sharing_consume_default_jquery_jquery": [
		"webpack/sharing/consume/default/@lumino/widgets",
		"webpack/sharing/consume/default/jquery/jquery?123b"
	],
	"webpack_sharing_consume_default_lumino_coreutils": [
		"webpack/sharing/consume/default/@lumino/coreutils"
	],
	"webpack_sharing_consume_default_jupyter-widgets_base_jupyter-widgets_base": [
		"webpack/sharing/consume/default/@jupyter-widgets/base/@jupyter-widgets/base"
	],
	"webpack_sharing_consume_default_lumino_algorithm-webpack_sharing_consume_default_lumino_signaling": [
		"webpack/sharing/consume/default/@lumino/algorithm",
		"webpack/sharing/consume/default/@lumino/signaling"
	],
	"lib_index_js": [
		"webpack/sharing/consume/default/@jupyterlab/settingregistry",
		"webpack/sharing/consume/default/@jupyterlab/console",
		"webpack/sharing/consume/default/@jupyterlab/notebook",
		"webpack/sharing/consume/default/@jupyterlab/mainmenu",
		"webpack/sharing/consume/default/@jupyterlab/rendermime",
		"webpack/sharing/consume/default/@jupyterlab/logconsole",
		"webpack/sharing/consume/default/@lumino/disposable",
		"webpack/sharing/consume/default/@jupyter-widgets/base-manager/@jupyter-widgets/base-manager",
		"webpack/sharing/consume/default/semver/semver",
		"webpack/sharing/consume/default/@jupyter-widgets/output/@jupyter-widgets/output",
		"webpack/sharing/consume/default/@jupyterlab/outputarea",
		"webpack/sharing/consume/default/@jupyterlab/services",
		"webpack/sharing/consume/default/@jupyterlab/translation"
	],
	"webpack_sharing_consume_default_lumino_messaging": [
		"webpack/sharing/consume/default/@lumino/messaging"
	],
	"packages_base_lib_index_js-webpack_sharing_consume_default_jquery_jquery": [
		"webpack/sharing/consume/default/jquery/jquery?5edd"
	],
	"packages_controls_lib_index_js": [
		"webpack/sharing/consume/default/@lumino/domutils"
	],
	"@jupyter-widgets/controls": [
		"webpack/sharing/consume/default/@jupyter-widgets/controls/@jupyter-widgets/controls"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}